/* eslint-disable react/forbid-elements */
import {
  Button,
  CompassIcon,
  H2,
  Image,
  LightningIcon,
  MessagesIcon,
  Paragraph,
  YStack,
} from '@bounty/creators-design-system'
import CreatorTable from '../../../assets/bounty-creator-table.png'
import { useBrandSignUpModal } from './SignUpModal'

const TalkToSales = () => {
  const [, setOpen] = useBrandSignUpModal()

  return (
    <Button
      event="Brands How It Works Section Talk to Sales Clicked"
      onPress={() => setOpen(true)}
    >
      Talk to Sales
    </Button>
  )
}

const valueProps = [
  {
    icon: CompassIcon,
    title: 'Streamlined Discovery',
    text: 'New creators every month sourced just for you. Handpick on the ones you like and let Bounty handle the rest.',
    renderBottom: () => {
      return <TalkToSales />
    },
  },
  {
    icon: LightningIcon,
    title: 'Effortless Activation',
    text: 'Recruit customers and creators through email, SMS, DMs, or directly on your website with invites flows and widgets.',
  },
  {
    icon: MessagesIcon,
    title: 'Ongoing Engagement',
    text: 'Engage and re-engage your top creators to bring your partnership to a whole new level, all in one place.',
  },
]

export const HowItWorks = () => {
  return (
    <YStack px="$4" py="$3" width="100%" maxWidth={1300} alignSelf="center">
      <YStack
        borderWidth={1}
        borderColor="$blackAlpha.100"
        borderRadius={'$8'}
        py="$8"
        px="$5"
        backgroundColor={'$neutral.100'}
        overflow="hidden"
        $gtMd={{ flexDirection: 'row', py: '$24', pl: '$16' }}
      >
        <YStack flex={1} $gtMd={{ py: '$6' }}>
          <H2
            textAlign="center"
            size="$2xl"
            color="rgba(92, 225, 230, 1)"
            mb="$6"
            $gtMd={{
              fontSize: '$4xl',
              textAlign: 'left',
            }}
          >
            Discovery and activation on autopilot
          </H2>

          <YStack space="$9" mb="$6" $gtMd={{ mb: 0 }}>
            {valueProps.map(({ title, text, icon: Icon, renderBottom }) => {
              return (
                <YStack
                  flex={1}
                  key={title}
                  alignItems="center"
                  $gtMd={{
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    width: '100%',
                    space: '$4',
                  }}
                >
                  <YStack mb="$2">
                    <Icon
                      weight="fill"
                      color="rgba(92, 225, 230, 1)"
                      size={32}
                    />
                  </YStack>
                  <YStack flex={1}>
                    <Paragraph
                      textAlign="center"
                      mb="$1"
                      color="rgba(92, 225, 230, 1)"
                      size="$xl"
                      $gtMd={{ textAlign: 'left' }}
                    >
                      {title}
                    </Paragraph>
                    <Paragraph
                      textAlign="center"
                      color="$neutral.700"
                      mb={renderBottom ? '$3' : ''}
                      $gtMd={{ textAlign: 'left' }}
                    >
                      {text}
                    </Paragraph>
                    <YStack
                      alignItems="center"
                      $gtMd={{ alignItems: 'flex-start' }}
                    >
                      {renderBottom?.()}
                    </YStack>
                  </YStack>
                </YStack>
              )
            })}
          </YStack>
        </YStack>
        <YStack
          flex={1}
          overflow="hidden"
          borderWidth={5}
          borderColor="rgba(92, 225, 230, 1)"
          borderRadius={'$5'}
          height={370}
          width={556}
          $gtSm={{ alignSelf: 'flex-end', right: -50 }}
          $gtMd={{ display: 'none' }}
        >
          <Image src={CreatorTable} height={'100%'} width={'100%'} />
        </YStack>

        <YStack
          flex={1}
          overflow="hidden"
          borderWidth={2}
          borderColor="$neutral.200"
          borderRadius={'$5'}
          height={616}
          width={2000}
          $gtSm={{ alignSelf: 'flex-end', right: -50 }}
          display="none"
          $gtMd={{ display: 'flex' }}
        >
          <img
            loading="lazy"
            alt="Creator table inside of bounty"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'left',
            }}
            src={CreatorTable}
          />
        </YStack>
      </YStack>
    </YStack>
  )
}
